import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GradienButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_GRADIEN_BUTTONS, FLAT_GRADIEN_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatGradienButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={GradienButton} span={FLAT_GRADIEN_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn color="primary-gradien" id="Tooltip-75" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-75" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary-gradien</ToolTip>
          {FLAT_GRADIEN_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} />
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatGradienButtons;
